export default "__VITE_ASSET__B94yG9Ho__"